export default function TransactionItem({ name, date, amount, status }) {
  const s = (status || "").toLowerCase();

  const badge = (() => {
    if (s.includes("succ")) return { bg: "bg-green-500/10", text: "text-green-600", label: status || "Succès", icon: "✅" };
    if (s.includes("cours") || s.includes("pending")) return { bg: "bg-amber-500/10", text: "text-amber-600", label: status || "En cours", icon: "⏳" };
    if (s.includes("échec") || s.includes("annul") || s.includes("fail")) return { bg: "bg-red-500/10", text: "text-red-600", label: status || "Échec", icon: "❌" };
    return { bg: "bg-slate-500/10", text: "text-slate-600", label: status || "Info", icon: "ℹ️" };
  })();

  return (
    <div
      className="rounded-2xl border border-black/5 dark:border-white/10
                 bg-white dark:bg-slate-950
                 px-4 py-3 flex items-center justify-between gap-4"
    >
      <div className="min-w-0">
        <div className="font-medium text-slate-900 dark:text-white truncate">
          {name || "Transaction"}
        </div>
        <div className="text-xs text-slate-500 dark:text-slate-400">
          {date || "—"}
        </div>
      </div>

      <div className="text-right">
        <div className="font-semibold text-slate-900 dark:text-white">
          {amount || "—"}
        </div>

        <div className={`mt-1 inline-flex items-center gap-1 rounded-xl px-2 py-1 text-xs ${badge.bg} ${badge.text}`}>
          <span>{badge.icon}</span>
          <span className="font-medium">{badge.label}</span>
        </div>
      </div>
    </div>
  );
}
